import Vue from 'vue'
import Router from 'vue-router'
import login from '../views/login/login'
import navList from '../views/nav-list/nav-list'
import upgradeManagement from '../views/upgrade-management/upgrade-management'
import modifyDevice from '../views/upgrade-management/modify-device'
import addDevice from '../views/upgrade-management/add-device'
import versionManagement from '../views/version-management/version-management'
// import userManagement from '../views/user-management/user-management'
import configManagement from '../views/config-management/config-management'
import addConfig from '../views/config-management/add-config'
import modifyConfig from '../views/config-management/modify-config'
import log from '../views/log/log-page'
import factoryAllocation from '../views/factory-allocation/factory-allocation'
import productionBath from '../views/factory-allocation/production-bath'
import firmwareVersion from '../views/factory-allocation/firmware-version'
import productModel from '../views/factory-allocation/product-model'
import cooperativePartner from '../views/warehouse-management/cooperative-partner'
import addPartner from '../views/warehouse-management/and-partner'
import modifyPartner from '../views/warehouse-management/modify-partner'
import businessManagement from '../views/warehouse-management/business-management'
import addBusiness from '../views/warehouse-management/add-business'
import modifyBusiness from '../views/warehouse-management/modify-business'
import warehouseRecord from '../views/warehouse-management/warehouse-record'
import accountManagement from '../views/account/account-management'
import addAccount from '../views/account/add-account'
import modifyAccount from '../views/account/modify-account'
import roleManagement from '../views/account/role-management'
import queryShort from '../views/query-short/query-short'
import queryDevice from '../views/query-device/query-device'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/login',
      component: login
    }, {
      path: '/login',
      name: 'login',
      component: login
    }, {
      path: '/navlist',
      name: 'nav-list',
      component: navList,
      children: [
        {
          path: '/upgrade_management',
          name: 'upgrade-management',
          component: upgradeManagement
        }, {
          path: '/add_device',
          name: 'add-device',
          component: addDevice
        }, {
          path: '/modify_device/:id',
          name: 'modify-device',
          component: modifyDevice
        }, {
          path: '/version_management',
          name: 'version-management',
          component: versionManagement
        }, {
          path: '/config_management',
          name: 'config-management',
          component: configManagement
        }, {
          path: '/add_config',
          name: 'add-config',
          component: addConfig
        }, {
          path: '/modify_config/:id',
          name: 'modify-config',
          component: modifyConfig
        }, {
          path: '/log',
          name: 'log-page',
          component: log
        }, {
          path: '/factory_allocation',
          name: 'factory-allocation',
          component: factoryAllocation
        }, {
          path: '/production_bath',
          name: 'production-bath',
          component: productionBath
        }, {
          path: '/firmware_version',
          name: 'firmware-version',
          component: firmwareVersion
        }, {
          path: '/product_model',
          name: 'product-model',
          component: productModel
        }, {
          path: '/cooperative_partner',
          name: 'cooperative_partner',
          component: cooperativePartner
        }, {
          path: '/add_partner',
          name: 'add-partner',
          component: addPartner
        }, {
          path: '/modify_partner/:id',
          name: 'modify-partner',
          component: modifyPartner
        }, {
          path: '/business_management',
          name: 'business-management',
          component: businessManagement
        }, {
          path: '/add_business',
          name: 'add-business',
          component: addBusiness
        }, {
          path: '/modify_business/:id',
          name: 'modify-business',
          component: modifyBusiness
        }, {
          path: '/warehouse_record',
          name: 'warehouse-record',
          component: warehouseRecord
        }, {
          path: '/account_management',
          name: 'account-management',
          component: accountManagement
        }, {
          path: '/add_account',
          name: 'add-account',
          component: addAccount
        }, {
          path: '/modify_account/:id',
          name: 'modify-account',
          component: modifyAccount
        }, {
          path: '/role_management',
          name: 'role-management',
          component: roleManagement
        }, {
          path: '/query_short',
          name: 'query-short',
          component: queryShort
        }, {
          path: '/query_device',
          name: 'query-device',
          component: queryDevice
        }
      ]
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js